;document.body.addEventListener('CPB_ON_PRODUCT_MOUNTED', function(event) {
  console.log('CPB is loaded');
  customJS.init();
});
;(function($) {
document.body.addEventListener('CPB_ON_PRODUCT_MOUNTED', init);

function init() {
  modifyProductInCartInit();
}

function modifyProductInCartInit() {
  if(window.location.search.indexOf('&modifyProduct=') === -1) return;
  var keyId = window.location.search.split('&modifyProduct=')[1];
  keyId = keyId.split('&')[0];
  var addToCartBtn = $('.cpb-add-to-cart-button');
  addToCartBtn.find('span').html('Update Cart');
  addToCartBtn.on('click', function() {
  $.get('/cart/change.js', {
    'id': keyId,
    'quantity': 0
  });
});
}

})(jQuery);

document.addEventListener('click',function(e){
  if(e.target && e.target.classList.contains('personalize-it--js')){
    window.dispatchEvent(new Event('resize'));
  }
});

var customJS = {
  init: function () {
    this.initGlobals();
    this.editProduct();
    this.reInit(this);
  },
  initGlobals: function() {
    window.dispatchEvent(new Event('resize'));
  },
  editProduct: function() {
    if(window.location.search.indexOf('&modifyProduct=') === -1) return;
    let keyId = window.location.search.split('&modifyProduct=')[1];
    keyId = keyId.split('&')[0];
    let upd = {};
    upd.updates = {[keyId]: 0}
    const addToCartBtn = document.querySelector('.cpb-add-to-cart-button');
    addToCartBtn.querySelector('span').innerHTML = 'Update Cart';
    addToCartBtn.addEventListener('click', function() {
      updateCart(upd).catch( error => {
        console.log(error);
      })
    });
    async function updateCart(updates) {
    const response = await fetch('/cart/update.js', {
                            method: 'POST',
                            body: JSON.stringify(updates),
                            headers: {
                              'Content-type': 'application/json; charset=UTF-8'
                            }
                          });
    if (!response.ok) {
      const message = `An error has occured: ${response.status}`;
      throw new Error(message)
    }
  }
  },
  reInit: function(_this) {
  	document.body.addEventListener('CPB_ON_OPTIONS_UPDATE', function(event) {

  	});
  	document.body.addEventListener('CPB_ON_UPDATE_CURRENT_TAB', function(event) {

  	})
  }
}